/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import CompaniesListPage from '../../pages/Company/CompaniesListPage';
import ImportCompanyPage from '../../pages/Company/ImportCompanyPage';
import NotFoundPage from '../../pages/NotFoundPage';
import CompanyDetailPage from '../../pages/Company/CompanyDetailPage';
import SignUpPage from '../../pages/SignUpPage';
import UsersListPage from '../../pages/Company/UsersListPage';
import MaintenancePage from '../../pages/MaintenancePage';
import DashboardPage from '../../pages/DashboardPage';
import CourseListPage from '../../pages/CourseListPage';
import EmployeeListPage from '../../pages/Employees/EmployeeListPage';
import PlanningPage from '../../pages/PlanningPage';
import EmployeeDetailPage from '../../pages/Employees/EmployeeDetailPage';
import LogbookPage from '../../pages/LogbookPage';
import LogbookDetailPage from '../../pages/LogbookDetailPage';
import SettingsPage from '../../pages/SettingsPage';
import CertificatePage from '../../pages/CertificatePage';
import EditUserPage from '../../pages/EditUserPage';

function DationInstanceUserRouter({ isSuperUser, handleSignOut }) {
	return (
		<Switch>
			<Route exact path={ROUTES.LOGIN} element={<Navigate to={ROUTES.COMPANIES} />} />
			<Route exact path={ROUTES.LANDING} element={<Navigate to={ROUTES.COMPANIES} />} />
			<Route exact path={ROUTES.COMPANIES} element={<CompaniesListPage />} />
			<Route exact path={ROUTES.IMPORT_COMPANY} element={<ImportCompanyPage />} />
			<Route exact path={`${ROUTES.COMPANIES}/:companyId`} element={<CompanyDetailPage />} />

			<Route
				exact
				path={ROUTES.resetPasswordRequestPage()}
				Component={() => {
					handleSignOut();
					return <SignUpPage />;
				}}
			/>
			<Route exact path="/notFound" element={<NotFoundPage />} />
			<Route exact path={ROUTES.MAINTENANCE} element={<MaintenancePage />} />
			{isSuperUser && <Route exact path={ROUTES.USERS} element={<UsersListPage />} />}
			{/* Shared with CompanyUserRouter */}
			<Route exact path={`${ROUTES.DASHBOARD}`} element={<DashboardPage />} />
			<Route exact path={ROUTES.INVENTORY} element={<CourseListPage />} />
			<Route exact path={ROUTES.EMPLOYEES} element={<EmployeeListPage />} />
			<Route exact path={ROUTES.COURSE_PLANNING} element={<PlanningPage />} />
			<Route exact path={`${ROUTES.EMPLOYEES}/:employeeId`} element={<EmployeeDetailPage />} />
			<Route exact path={`${ROUTES.LOGBOOK}`} element={<LogbookPage />} />
			<Route exaxt path={`${ROUTES.LOGBOOK}/:logbookEntryId`} element={<LogbookDetailPage />} />
			<Route exaxt path={`${ROUTES.SETTINGS}`} element={<SettingsPage />} />
			<Route exact path={ROUTES.CERTIFICATES} element={<CertificatePage />} />
			<Route exact path={ROUTES.EDIT_USER} element={<EditUserPage />} />
		</Switch>
	);
}

export default DationInstanceUserRouter;
